import Rellax from "rellax";

function scrollRellax() {
  let fastOptions2x = {
    speed: 2,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  };
  let fastOptions4x = {
    speed: 4,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  };
  let slowOptions2x = {
    speed: -2,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  };
  let slowOptions4x = {
    speed: -4,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  };
  $('.rellax-fast-2x') && new Rellax('.rellax-fast-2x', fastOptions2x);
  $('.rellax-fast-4x') && new Rellax('.rellax-fast-4x', fastOptions4x);
  $('.rellax-slow-2x') && new Rellax('.rellax-slow-2x', slowOptions2x);
  $('.rellax-slow-4x') && new Rellax('.rellax-slow-4x', slowOptions4x);
}
scrollRellax();